/**
 * Pillar breakdown for the Grounded Score.
 * Presentation-only: returns the letter grade and factual label for each
 * pillar so public guide pages can render per-pillar detail without exposing
 * point values or weights. Scoring itself lives in src/lib/workScore.ts.
 */

import {
  getWifiGrade,
  getOutletsGrade,
  getSeatingGrade,
  getParkingGrade,
  type LetterGrade,
} from "@/lib/amenityGrades";

export interface AmenityInputs {
  wifi_type?: string | null;
  outlet_availability?: string | null;
  seating_capacity?: string | null;
  parking_available?: string | null;
}

export interface PillarGrade {
  grade: LetterGrade;
  label: string;
}

export interface PillarBreakdown {
  wifi: PillarGrade;
  outlets: PillarGrade;
  seating: PillarGrade;
  parking: PillarGrade;
}

export function computePillarBreakdown(a: AmenityInputs): PillarBreakdown {
  const wifi = getWifiGrade({ wifi_type: a.wifi_type, has_wifi: a.wifi_type ? a.wifi_type !== "none" : undefined });
  const outlets = getOutletsGrade({ outlet_availability: a.outlet_availability });
  const seating = getSeatingGrade({ seating_capacity: a.seating_capacity });
  const parking = getParkingGrade({ parking_available: a.parking_available });

  return {
    wifi: { grade: wifi.grade, label: wifi.subtitle },
    outlets: { grade: outlets.grade, label: outlets.subtitle },
    seating: { grade: seating.grade, label: seating.subtitle },
    parking: { grade: parking.grade, label: parking.subtitle },
  };
}
